module.exports = {
  ScheduledContributionsComponentEvents: {
    ScheduledContributions: {
      code: 'ScheduledContribution',
      events: {
        Loaded: {
          description: 'Triggers when the Schedules tab is clicked/loaded.',
          eventHub: {
            code: 'ScheduledContribution',
            action: 'DashboardSchedules_Loaded'
          },
          ga: {
            action: 'DashboardSchedules_Loaded'
          }
        },
        ScheduleContributionClicked: {
          description: 'Triggers on click of Schedule contribution CTA.',
          eventHub: {
            code: 'ScheduledContribution',
            action: 'DashboardSchedules_ScheduleContribution_Clicked'
          },
          ga: {
            action: 'DashboardSchedules_ScheduleContribution_Clicked'
          }
        },
        ViewAllClicked: {
          description: 'Triggers on click of View all CTA.',
          eventHub: {
            code: 'ScheduledContribution',
            action: 'DashboardSchedules_ViewAll_Clicked'
          },
          ga: {
            action: 'DashboardSchedules_ViewAll_Clicked'
          }
        },
        ViewAllLoaded: {
          description: 'Triggers when view all contributions page is loaded.',
          eventHub: {
            code: 'ScheduledContribution',
            action: 'DashboardSchedules_ViewAll_Loaded'
          },
          ga: {
            action: 'DashboardSchedules_ViewAll_Loaded'
          }
        },
        ScheduleDetailsLoaded: {
          description: 'Triggers when schedule details is loaded for a specific contribution.',
          eventHub: {
            code: 'ScheduledContribution',
            action: 'DashboardSchedules_ScheduleDetails_Loaded'
          },
          ga: {
            action: 'DashboardSchedules_ScheduleDetails_Loaded'
          }
        },
        CancelContributionClicked: {
          description: 'Triggers on click of Cancel contribution CTA.',
          eventHub: {
            code: 'ScheduledContribution',
            action: 'DashboardSchedules_CancelContribution_Clicked'
          },
          ga: {
            action: 'DashboardSchedules_CancelContribution_Clicked'
          }
        }
      }
    }
  }
};
